import {EmptyObject} from "../common-types";

type ShouldNotTranslateAttributes = {
    translate: 'no'
}

export function htmlShouldNotTranslate () : ShouldNotTranslateAttributes;
export function htmlShouldNotTranslate (shouldNotTranslate: true) : ShouldNotTranslateAttributes;
export function htmlShouldNotTranslate (shouldNotTranslate: false) : EmptyObject;
export function htmlShouldNotTranslate (shouldNotTranslate: boolean) : ShouldNotTranslateAttributes | EmptyObject;
export function htmlShouldNotTranslate (shouldNotTranslate = true) : ShouldNotTranslateAttributes | EmptyObject {

    if (shouldNotTranslate) {
        return {
            translate: 'no'
        } as const
    } else {
        return {}
    }
}

const SameOriginIframeMarkingAttributeName = 'data-same-origin-iframe';

export function htmlSameOriginIframeCreateMarking () {
    return {
        [SameOriginIframeMarkingAttributeName]: 'true'
    }
}

export function htmlSameOriginIframeCreateSelector () {
    return `[${SameOriginIframeMarkingAttributeName}]`
}